import { render, staticRenderFns } from "./EditObservations.vue?vue&type=template&id=1771f898&"
import script from "./EditObservations.vue?vue&type=script&lang=js&"
export * from "./EditObservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports